import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import { withTranslation } from 'react-i18next';
import sentGAEvent from '@/ga';
import Utils from '@/utils';

import { ReactComponent as Notice } from "@/assets/icons/notice1.svg";
import { ReactComponent as Mac } from "@/assets/icons/mac.svg";
import { ReactComponent as Win } from "@/assets/icons/win.svg";
import { ReactComponent as Select } from "@/assets/icons/gou.svg";
import hitpawToolkitBox from "@/assets/images/HitPaw-Online-Audio-Converter.png";
import HitPawWatermarkRemoverBox from "@/assets/images/hitpaw-watermark-remover-box.png";
import '@/assets/exceed20m.less'
class TipsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productIntrInfoList: [
        {
          key: 'hitpaw-toolkit',
          title: 'HitPaw Video Converter',
          box: hitpawToolkitBox,
          list: [
            'Download desktop version to batch process large files with no size limit',
            'Batch convert video and audio files to 1000+ formats with 120X faster speed',
            'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.',
            // 'Built-in rich video editing features: merge, cut, crop, watermark, etc.',
            'Convert Apple Music to MP3 with DRM removed (Windows version only)',
          ],
        },
        {
          key: 'hitpaw-watermark-remover',
          title: 'HitPaw Watermark Remover',
          box: HitPawWatermarkRemoverBox,
          list: [
            '0 second wait',
            'No size limits',
            'Support 1000+ formats',
            'Remove watermark from videos and images in simple clicks',
          ],
        },
      ],
    };
  }

  downloadFile = () => {
    sentGAEvent({
      category: 'Download',
      action: 'URLVidDownload',
    });
  };

  getProductName = () => {
    const key = this.props.productKey
      ? this.props.productKey
      : 'hitpaw-toolkit';
    return this.state.productIntrInfoList.filter((item) => item.key === key)[0]
      .title;
  };

  goVideoConverter = (action) => {
    // window.open(Utils.getHitPawConvertLink())
    window.location.href = Utils.getHitPawConvertLink()
    this.handleDownloadGA(action)
  }

  handleDownloadGA = (action) => {
    sentGAEvent({
      category: 'Download',
      action: action,
      label:
        this.props.work === 'audioCompress'
          ? 'audio_compress'
          : this.props.work === 'audioExtractor'
          ? 'audio_extractor'
          : this.props.work === 'audioJoiner'
          ? 'audio_merger'
          : this.props.work === 'audioCut'
          ? 'audio_cut'
          : this.props.work === 'audioVolume'
          ? 'audio_volume'
          : this.props.work === 'audioSpeed'
          ? 'audio_speed'
          : this.props.work === 'audioAddMusic'
          ? 'add_bgm'
          : this.props.tipsObj
          ? this.props.tipsObj.type === 'urlSize'
            ? 'url'
            : this.props.tipsObj.type
          : '',
    });
  };

  render() {
    const { t } = this.props;
    const { productIntrInfoList } = this.state;
    return (
      <div className='exceed20'>
        <Modal
          centered
          visible={this.props.visible}
          onCancel={this.props.onCancel}
          footer={null}
          maskClosable={false}
          getContainer={document.querySelector('.Home')}
          className='tipsModal tipsProductModal fProductModal'
        >
          <div className='f-header'>
            <Notice
              style={{
                width: '2rem',
                height: '2rem',
                flexShrink: 0,
                marginRight: '20px',
              }}
            />
            {this.props.title && (
              <span style={{ display: 'block' }}>{t(this.props.title)}</span>
            )}
            {this.props.hasFileDownload ? (
              <span>
                {t(this.props.content)}
                <a
                  style={{ textDecoration: 'underline' }}
                  href={this.props.fileObj.videofileurl}
                  target='_blank'
                  rel='noopener noreferrer'
                  onClick={this.downloadFile}
                >
                  {t(this.props.contentLink)}
                </a>
                {t(this.props.content2)}
              </span>
            ) : (
              <span>
                {t(this.props.content, { name: this.getProductName() })}
                {this.props.hasDownload && !this.props.learnMoreHidden ? (
                  <a
                    href={Utils.getHitPawConvertSeoLink()}
                    style={{
                      marginLeft: '0.5rem',
                      textDecoration: 'underline',
                    }}
                    // onClick={this.props.cancelBtnHandle}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    {t('Learn more')}
                  </a>
                ) : null}
              </span>
            )}
            {/* {this.props.hasDownload && !this.props.learnMoreHidden ? (
            <a
              href={Utils.getHitPawHomeLink()}
              style={{ marginLeft: "0.5rem", textDecoration: "underline" }}
              onClick={this.props.cancelBtnHandle}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("Learn more")}
            </a>
          ) : null} */}
          </div>
          {productIntrInfoList
            .filter(
              (item) =>
                item.key ===
                (this.props.productKey
                  ? this.props.productKey
                  : 'hitpaw-toolkit')
            )
            .map((item) => (
              <div className='f-cont' key={item.key}>
                <div className='flft'>
                  <img src={item.box} alt='product' />
                </div>
                <div className='rgt'>
                  <p>{item.title}</p>
                  <div className='messui'>
                    {item.list.map((con, i) => (
                      <div key={i}><Select style={{marginRight:'6px',}}></Select>{t(con)}</div>
                    ))}
                  </div>
                  {item.key === 'hitpaw-toolkit' ? (
                    <div className='btn-groups'>
                      {/* <Button
                        className='try'
                        // type='primary'
                        href={Utils.getHitPawConvertLink()}
                        target='_blank'
                        rel='noopener noreferrer'
                        onClick={() => this.goVideoConverter('ToolkitDownload')}
                        size='large'
                      >
                        <Win className='winmac' />
                        {t('TRY IT FREE')}
                      </Button> */}
                      <div className='try' onClick={() => this.goVideoConverter('ToolkitDownload')}>
                        {window.userClient.platform === 'win' ? (
                          <Win className='winmac' />
                        ) : (
                          <Mac className='winmac' />
                        )}
                        {t('TRY IT FREE')}
                      </div>
                      {/* <Button
                      ghost
                      type="primary"
                      href={Utils.getHitPawToolKitBuyLink()}
                      target="_blank"
                      rel="noopener noreferrer"
                      // onClick={this.props.confirmBtnHandle}
                      size="large"
                    >
                      <Win />
                      {t("BUY NOW")}
                    </Button> */}
                    </div>
                  ) : (
                    <div className='btn-groups'>
                      <Button
                        type='primary'
                        href={Utils.getHitPawWatermarkRemoverEXELink(
                          window.userClient.platform === 'win' ? 'win' : 'mac'
                        )}
                        target='_blank'
                        rel='noopener noreferrer'
                        onClick={() => this.handleDownloadGA('RemoverDownload')}
                        size='large'
                      >
                        {window.userClient.platform === 'win' ? (
                          <Win className='winmac' />
                        ) : (
                          <Mac className='winmac' />
                        )}
                        {t('Try It Free')}
                      </Button>
                      {/* <Button
                      ghost
                      type="primary"
                      href={Utils.getHitPawWatermarkRemoverBuyLink(window.userClient.platform === "win" ? "win" : "mac")}
                      target="_blank"
                      rel="noopener noreferrer"
                      size="large"
                    >
                      {window.userClient.platform === "win" ? <Win /> : <Mac />}
                      {t("Buy Now")}
                    </Button> */}
                    </div>
                  )}
                </div>
              </div>
            ))}
        </Modal>
      </div>
    );
  }
}
export default withTranslation(['common'])(TipsModal);
